import type { CSSObject } from "@emotion/react";
import { css } from "@emotion/react";
import { vars } from "@imwebme/clay-token";
import type { CardProps } from "./Card.types";

const gapSizeMap = ({ size, inline }: Pick<CardProps, "size" | "inline">): CSSObject => {
  if (size !== "small") {
    return {
      gap: vars.spacing[4],
    };
  }

  if (inline) {
    return {
      gap: "24px",
    };
  }

  return {};
};

export const cardCSS = ({ size, inline }: Pick<CardProps, "size" | "inline">) =>
  css({
    display: "flex",
    flexDirection: "column",

    paddingLeft: vars.spacing[6],
    paddingRight: vars.spacing[6],

    backgroundColor: vars.semantic.color.surface,
    borderRadius: vars.rounded.large,

    paddingTop: vars.spacing[5],

    "&:has(>[data-clay-header])": {
      paddingTop: vars.spacing[size === "small" ? 5 : 6],
    },

    ...gapSizeMap({ size, inline }),
  });
